// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX Modules
import DeliveryOptionCalculator from '../../_utils/_delivery-options/calculator';
// Import JS Modules
import translate from '../tools/translate';

// -----------------------------------------------------------
//  DeliveryOptionIcon
// -----------------------------------------------------------
const DeliveryOptionIcon = ({ option, hideIcon, unavailable }) => {
  if (!option) {
    return (
      <span className="delivery-option-icon">
        Not set
      </span>
    );
  }

  const { text, icon } = (({ type, time_hours: hours, title = '' }) => {
    switch (type) {
      case 'PICKUP':
        if (hours >= DeliveryOptionCalculator.FIVE_DAYS)
          return {
            text: title,
            icon: 'fas fa-store'
          };

        if (hours >= DeliveryOptionCalculator.TWENTY_FOUR_HOURS)
          return {
            text: title,
            icon: 'far fa-clock'
          };

        return {
          text: title,
          icon: 'far fa-clock'
        };

      case 'POST':
        return {
          text: title,
          icon: 'fas fa-truck',
        };

      case 'COURIER':
        return {
          text: title,
          icon: 'fas fa-box',
        };

      case 'COLLECT':
        return {
          text: title || 'Collection',
          icon: 'fas fa-globe',
        };

      case 'POST_EXPRESS':
        return {
          text: title || 'Express ' + translate('Home Delivery'),
          icon: 'fas fa-shipping-fast',
        };

      case 'COURIER_EXPRESS':
        return {
          text: title || 'Express ' + translate('Home Delivery') + ' via Courier',
          icon: 'fas fa-box',
        };

      default:
        return {
          text: translate('Other Delivery'),
          icon: 'fas fa-gift',
        };
    }
  })(option);

  return (
    <span className={classNames('delivery-option-icon', { unavailable })}>
      {!hideIcon && <i className={icon} />}
      <span className="delivery-option-title">{text}</span>
      {unavailable && <span className="unavailable-text">Unavailable</span>}
    </span>
  );
};

DeliveryOptionIcon.displayName = 'Delivery Option Icon';

export default DeliveryOptionIcon;
